import { Country } from '@afterpay/types'

export const COUNTRIES_WITH_BILLING_ADDRESS_REQUIREMENTS: Array<Country | undefined> = [Country.GB, Country.US, Country.CA]
